var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressLineEnable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 8,
    viewBox: "0 0 77 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.5C0.223858 3.5 0 3.72386 0 4C0 4.27614 0.223858 4.5 0.5 4.5V3.5ZM76.8536 4.35355C77.0488 4.15829 77.0488 3.84171 76.8536 3.64645L73.6716 0.464466C73.4763 0.269204 73.1597 0.269204 72.9645 0.464466C72.7692 0.659728 72.7692 0.976311 72.9645 1.17157L75.7929 4L72.9645 6.82843C72.7692 7.02369 72.7692 7.34027 72.9645 7.53553C73.1597 7.7308 73.4763 7.7308 73.6716 7.53553L76.8536 4.35355ZM0.5 4.5H76.5V3.5H0.5V4.5Z",
    fill: "#F8B117"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressLineEnable);
export default __webpack_public_path__ + "static/media/progress-line-enable.5fe0e15cd3e15ccdac587faa329aa226.svg";
export { ForwardRef as ReactComponent };